import React, { Component } from "react";
import {View, Image, TouchableOpacity, FlatList, TouchableWithoutFeedback} from 'react-native'
import { icons } from "../theme/icons";
import { appStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { greenDarkColor, greenLightColor } from "../theme/colors";
import { myAddresBooksRequest, removeAddressBookRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import FavortiAddressItem from "../components/FavortiAddressItem";
import {hp, wp} from "../utils/responsive";
import {showPrompt} from "../utils/utils";

export default class FavoritAddressScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            favorits: [],
            waiting: false,
            showModal:false,
            selectedItem:null,
        }
    }
    _keyExtractor = (item, index) => index.toString();

    renderFavoritRow({ item, index }) {
        return <FavortiAddressItem
            navigation={this.props.navigation}
            data={item}
            onRemove={() => {
               this.setState({
                   selectedItem:item,
                   showModal:true
               })
            }}
            onRefresh={() => {
                this.getData()
            }} />
    }
    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon]} />
                <TextView style={appStyles.toolbarTitle}>آدرس های منتخب</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <FlatList
                data={this.state.favorits}
                renderItem={this.renderFavoritRow.bind(this)}
                keyExtractor={this._keyExtractor}
            />
            <TouchableOpacity style={appStyles.fabIconWraper} onPress={() => {
                this.props.navigation.navigate('createAddressBook', {
                    id: 0,
                    refresh: () => {
                        this.getData()
                    }
                })
            }}>
                <LinearGradient colors={[greenDarkColor, greenLightColor]} style={appStyles.fabIcon}>
                    <Image source={icons['add']} style={[appStyles.toolbarIcon, { tintColor: 'white' }]} />
                </LinearGradient>

            </TouchableOpacity>
            <Waiting waiting={this.state.waiting} />
            {this.state.showModal && <TouchableWithoutFeedback onPress={() => {
                this.setState({
                    showModal: false
                })
            }}>
                <View style={appStyles.modalMessageAbsolute} >
                    <View style={appStyles.modalMessageContent}>
                        <View style={[appStyles.rowAround, { marginTop: 15, marginBottom: 15 }]}>
                            <TouchableOpacity style={[appStyles.outlineButton, {
                                height: hp(6),
                                width: wp(30),
                                minWidth: wp(30),
                                borderRadius: 10,
                                margin: 5, alignSelf: 'center'
                            }]}
                                              onPress={() => {
                                                  this.setState({
                                                      showModal: false
                                                  }, () => {
                                                      setTimeout(() => {
                                                          showPrompt('حذف آدرس منتخب', 'آیا نسبت به حذف این آدرس اطمینان دارید؟', () => {
                                                              this.setState({
                                                                  waiting: true
                                                              })
                                                              removeAddressBookRequest(this.state.selectedItem.id, (isConnect, response) => {
                                                                  this.setState({
                                                                      waiting: false
                                                                  })
                                                                  if (isConnect && response.isSuccess) {
                                                                      this.getData()
                                                                  }
                                                              })

                                                          })
                                                      }, 200)

                                                  })
                                              }}>
                                <TextView style={{ textAlign: 'center' }}>حذف</TextView>
                            </TouchableOpacity>
                            <TouchableOpacity style={[appStyles.button, {
                                height: hp(6),
                                width: wp(30),
                                margin: 5, alignSelf: 'center'
                            }]}
                                              onPress={() => {
                                                  this.setState({
                                                      showModal: false
                                                  }, () => {
                                                      this.props.navigation.navigate('createAddressBook', {
                                                          id: this.state.selectedItem.id,
                                                          data: this.state.selectedItem,
                                                          refresh: () => {
                                                              this.getData()
                                                          }
                                                      })
                                                  })
                                              }}>
                                <TextView style={appStyles.buttonText}>ویرایش</TextView>
                            </TouchableOpacity>

                        </View>
                    </View>
                </View>
            </TouchableWithoutFeedback>}
        </View>)
    }

    componentDidMount() {
        this.getData()
    }
    getData() {
        this.setState({
            waiting: true
        })
        myAddresBooksRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    favorits: response.data
                })
            }
        })
    }
}
